<template>
  <el-dialog
  title="车辆管理"
  :visible.sync="show"
  :before-close="close"
  center
  destroy-on-close>
    <el-form
    ref="form"
    :rules="rules"
    :model="info"
    label-width="25%">
      <el-form-item label="车牌号" prop="carNo">
        <el-input  placeholder="请输入车牌号" v-model="info.carNo" maxlength="8"/>
      </el-form-item>
      <el-form-item label="品牌" prop="brand">
        <el-input  placeholder="请输入车辆品牌" v-model="info.brand" maxlength="20"/>
      </el-form-item>
      <el-form-item label="载人量" prop="capacity">
        <el-input-number
        :controls="false"
        placeholder="请输入车辆载人量"
        v-model="info.capacity"
        :max="100"
        style="width: 100%"/>
      </el-form-item>
      <el-form-item label="当前状态" prop="carStatus">
        <el-select placeholder="请选择当前状态" v-model="info.carStatus" style="width: 100%">
          <el-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="公司" prop="dataCompanyId">
        <el-select placeholder="请选择公司" v-model="info.dataCompanyId" style="width: 100%" multiple>
          <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName" :value="item.companyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" v-if="info.carStatus === '在用' && reason">
        <el-input
          type="textarea"
          autosize
          disabled
          class="reason"
          placeholder="请输入内容"
          v-model="reason">
        </el-input>        
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type !== 'see'">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { carTypeList } from '@/utils/constants'
import { add, query, update } from '@/api/carInfo'
import { listCompanyfInfo } from '@/api/searchList'

export default {
  data () {
    return {
      info: {
        carNo: '',
        brand: '',
        capacity: '',
        carStatus: '',
        dataCompanyId: []
      },
      rules: {
        carNo: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
        brand: [{ required: true, message: '请输入车辆品牌', trigger: 'blur' }],
        capacity: [{ required: true, message: '请输入车辆载人量', trigger: 'blur' }],
        carStatus: [{ required: true, message: '请选择车辆状态', trigger: 'change' }],
        dataCompanyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
      },
      stateList: carTypeList,
      type: '',
      show: false,
      reason: '',
      companyValueList: []

    }
  },
  mounted() {
    this.getCompanyList()
  },
  methods: {
     // 公司下拉框
    async getCompanyList() {
      let res = await listCompanyfInfo({})
      if (res.code === 0) {
        this.companyValueList = res.result
      }
    },
    showDetails (type, id) {
      this.type = type
      this.show = true
      if (id) {
        this.getDetails(id)
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    getDetails (id) {
      // console.log(id)
      query({
        id
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.info = {
          carNo: result?.records?.[0].carNo || '',
          brand: result?.records?.[0].brand || '',
          capacity: result?.records?.[0].capacity || '',
          carStatus: result?.records?.[0].carStatus || '',
          id
        }
        if (result?.records?.[0]?.dataCompanyId) {
          let dataCompanyId = result?.records?.[0]?.dataCompanyId.split(',').map(Number)
          this.$set(this.info, 'dataCompanyId', dataCompanyId)
        }
        this.reason = result?.records?.[0].reason
      })
    },
    close () {
      this.show = false
      this.info = {
        carNo: '',
        brand: '',
        capacity: '',
        carStatus: '',
        id: ''
      }
      this.reason = ''
    },
    addEventForm () {
      this.$refs.form.validate((vaild) => {
        // let dataCompany = JSON.parse(localStorage.getItem('jiadingFangwu_current_company'))
        if (vaild) {
          let params = {
            ...this.info,
            dataCompanyId: this.info.dataCompanyId.join(),
          }
          params.capacity = params.capacity.toString()
          console.log(params);
          (this.info.id ? update : add)(params).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$emit('addSuccess')
            this.close()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 450px;
  width: 30%;
  .reason .el-textarea__inner{
    font-size: 14px;
    color: #606266;
  }
}
</style>
